// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-woqVbwgT","ad_1":"ad_1-3tVj2uFw","ad_2":"ad_2-2fZmh29w"};